<template>
    <!-- <img class="anulada" src="img/anulado.png" alt="Anulada"> -->
    <v-sheet elevation="1" rounded height="80vh" class="pa-2" style="width: 8.6in; margin: auto; height: 100%;">
        <div class="botones">

            <v-menu ref="menu" v-model="menu" offset-y :close-on-content-click="false" transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" icon dark v-bind="attrs" v-on="on">
                        <v-icon dark>
                            mdi mdi-palette
                        </v-icon>
                    </v-btn>
                </template>
                <v-color-picker v-model="estilodoc.color" dot-size="25" swatches-max-height="200" closable>
                </v-color-picker>
                <div style="background-color: white; padding: 10px; text-align: center;">
                    <v-text-field v-model="estilodoc.color" label="HEX" dense outlined></v-text-field>
                    <v-btn color="primary" small dark @click="changeEstiloDoc('color',0)">Listo</v-btn>
                </div>
            </v-menu>

            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" icon dark v-bind="attrs" v-on="on">
                        <v-icon dark>
                            mdi mdi-format-font-size-increase
                        </v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item v-for="(size, index) in sizesFont" :key="index">
                        <v-list-item-title @click="changeEstiloDoc('font',size)">{{ size }}px</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" icon dark v-bind="attrs" v-on="on">
                        <v-icon dark>
                            mdi mdi-format-line-spacing
                        </v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item v-for="(size, index) in paddings" :key="index">
                        <v-list-item-title @click="changeEstiloDoc('padding',size)">{{ size }}px</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="green" icon @click="generarPDF()" v-bind="attrs" v-on="on">
                        <v-icon dark>
                            mdi mdi-printer
                        </v-icon>
                    </v-btn>
                </template>
                <span>Imprimir</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="red" icon @click="$router.go(-1)" v-bind="attrs" v-on="on">
                        <v-icon dark>
                            mdi mdi-close-circle-outline
                        </v-icon>
                    </v-btn>
                </template>
                <span>Cerrar</span>
            </v-tooltip>

        </div>
        <div id="printarea" style="width: 8.5in; height: auto;">
            <img class="anulada" src="@/assets/anulado.png" alt="Anulada" v-if="print.estado=='Anulada'">
            <table id="factura_head">
                <tr>
                    <td class="logo_factura">
                        <div>
                            <!-- <img src="@/assets/logo.png" width="100px"> -->
                            <img :src="estilodoc.logotipo" width="100px">

                        </div>
                    </td>
                    <td class="info_empresa">
                        <div>
                            <table>
                                <tr>
                                    <td>
                                        <h5 :style="{ color: estilodoc.color }" style="text-transform: uppercase;">
                                            <strong>{{print.idestablecimiento.nombrecomercial}}</strong>
                                        </h5>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding-bottom: 10px;">
                                        <strong
                                            style="text-transform: uppercase;">{{print.idestablecimiento.propietario}}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{`${print.idestablecimiento.direccion} ${print.idestablecimiento.municipio}
                                        ${print.idestablecimiento.departamento}`}}</td>
                                </tr>
                                <tr>
                                    <td>Nit: {{parseInt(print.idestablecimiento.nit)}}</td>
                                </tr>
                                <tr>
                                    <td>Teléfono: {{print.idestablecimiento.telefono}}</td>
                                </tr>
                            </table>


                        </div>
                    </td>
                    <td class="info_factura">
                        <div class="round" :style="{ borderColor: estilodoc.color }">
                            <span class="h3" :style="{ background: estilodoc.color }">{{print.documento}}</span>
                            <p style="margin-top: 10px;"><strong>Número: </strong> {{print.numero}}</p>
                            <p><strong>Serie: </strong> {{print.serie}}</p>
                            <p><strong>Fecha: </strong>{{ print.fecha | formatdate}}</p>
                            <p style="margin-top: -8px;" v-if="print.autorizacion.length>3">
                                <strong>Autorización: </strong> <br>
                                <span style="line-height:15px; font-size: 11px;">{{print.autorizacion}}</span>
                            </p>
                        </div>
                    </td>
                </tr>
            </table>
            <table id="factura_cliente">
                <tr>
                    <td class="info_cliente">
                        <div class="round" :style="{ borderColor: estilodoc.color }">
                            <span class="h3" :style="{ background: estilodoc.color }">Cliente</span>
                            <table class="datos_cliente">
                                <tr>
                                    <td>
                                        <p> <strong>Cliente:</strong> {{print.cliente}}</p>
                                    </td>
                                    <td width="15%">
                                        <p><strong>Nit:</strong> {{print.idpersona.nit}}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <p style="margin-top: -18px;"><strong>Dirección:</strong>
                                            {{print.idpersona.direccion}}</p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </td>

                </tr>
            </table>

            <table id="factura_detalle">
                <thead>
                    <tr>
                        <th width="50px" :style="{ background: estilodoc.color }">Cant.</th>
                        <th class="textleft" :style="{ background: estilodoc.color }">Descripción</th>
                        <th class="textright" width="150px" :style="{ background: estilodoc.color }">Precio Unitario.
                        </th>
                        <th class="textright" width="150px" :style="{ background: estilodoc.color }"> Precio Total</th>
                    </tr>
                </thead>
                <tbody id="detalle_productos">
                    <tr v-for="(item, index) in print.productos" :key="index"
                        :style="{ fontSize: estilodoc.fontsize+ 'px' }">
                        <td class="textcenter">{{ item.cantidad }}</td>
                        <td :style="{padding : estilodoc.padding+'px'}">{{ item.nombre }}</td>
                        <td class="textright">{{ item.precioventa| currency }}</td>
                        <td class="textright">{{ item.total | currency }}</td>
                    </tr>
                </tbody>
                <tfoot id="detalle_totales">
                    <tr>
                        <td colspan="3" class="textright"><span>SUBTOTAL</span></td>
                        <td class="textright"><span>{{ subtotal| currency }}</span></td>
                    </tr>
                    <tr>
                        <td colspan="3" class="textright"><span>DESCUENTOS</span></td>
                        <td class="textright"><span>{{totaldescuento| currency }}</span></td>
                    </tr>
                    <tr>
                        <td colspan="3" class="textright"><span>IVA</span></td>
                        <td class="textright"><span>{{totaliva| currency }}</span></td>
                    </tr>
                    <tr>
                        <td colspan="3" class="textright" style="font-size:medium;"><strong>TOTAL</strong></td>
                        <td class="textright" style="font-size:medium;"><strong>Q {{totalfactura| currency }}</strong>
                        </td>
                    </tr>
                </tfoot>
            </table>
            <div class="footer" v-if="print.documento=='Factura Electrónica'">

                <div v-if="print.idestablecimiento.codregimen=='GEN'">
                    <p :style="{ color: estilodoc.color }"> <strong>* SUJETO A PAGOS TRIMESTRALES ISR</strong></p>
                    <p>Certificador: Digifact Servicios, S.A. NIT: 7745482-0</p>
                </div>
                <div v-else>
                    <p :style="{ color: estilodoc.color }"> <strong>FACTURA DE PEQUEÑO CONTRIBUYENTE</strong></p>
                    <p>* No genera derecho a crédito fiscal</p>
                    <p>Certificador: Digifact Servicios, S.A. NIT: 7745482-0</p>
                </div>
            </div>
            <h4 class="label_gracias" :style="{ color: estilodoc.color }">¡Gracias por su compra! </h4>
        </div>

        <div style="text-align: center;" v-if="updatedoc">
            <v-btn :color="estilodoc.color" dark @click="patchEstiloDoc()">
                <v-icon dark>
                    mdi mdi-content-save
                </v-icon>
                 Guardar Cambios
            </v-btn>
        </div>
    </v-sheet>
</template>
<script>
import currency from "@/utils/currency.js";
import html2pdf from 'html2pdf.js';
import {mapGetters} from 'vuex'
import Swal from "sweetalert2";

export default {
    name: 'GenerarFactura',

    data: () => ({
        totalfactura:0,
        totaldescuento:0,
        subtotal:0,
        totaliva:0,
        paddings:[0,1,3,5,7,8,10],
        sizesFont:[11,12,14,16,18,20,22,24,26,28,30],
        updatedoc:false,
        menu:false
    }),
    computed:{
        ...mapGetters({
            print:"getDatatToPrint",
            estilodoc:"getEstiloDoc"
        })
    },
    async created() {     
        this.loadEstiloDoc(this.print.idestablecimiento.idestablecimiento)
        this.calcularTotales()
        this.calculoIVA()
    },
    methods: {
        async loadEstiloDoc(idestablecimiento){
            await this.$store.dispatch('getEstilos',idestablecimiento)
        },
        changeEstiloDoc(elemento='font',value=0){
            this.updatedoc = true
            this.menu = false
            if(elemento=='font')this.estilodoc.fontsize = value
            if(elemento=='padding')this.estilodoc.padding = value
            
        },
        async patchEstiloDoc(){
            await this.$store.dispatch('patchEstilo',this.estilodoc)
            Swal.fire({
                icon: "success",
                title: '¡Cambios Guardados exitosamente!',
                showConfirmButton: false,
                timer: 2500,
            });
            this.updatedoc = false
        },
        calcularTotales(){
            
            this.subtotal = currency(
                this.print.productos.reduce(
                    (total, current) =>
                        total +
                        (current.cantidad * current.precioventa),
                    0
                )
            );

            this.totaldescuento = currency(
                this.print.productos.reduce((total, current) =>
                    total + parseFloat(current.descuento)
                )
            );

            this.totalfactura = currency(this.subtotal - this.totaldescuento)

        },
        calculoIVA(){
            const regimen = this.print.idestablecimiento.codregimen
            if(regimen=='GEN') this.totaliva = currency( (this.totalfactura/1.12) * 0.12)
            if(regimen=='PEQ') this.totaliva = currency( this.totalfactura * 0.05)
        },
        generarPDF() {
            const element = document.getElementById('printarea');
            var opt = {
                margin: [0.2, 0, 0.1 ,0], // [top, left, bottom, right]
                filename: 'myfile.pdf',
                image: { type: 'jpeg', quality: 0.99 },
                html2canvas: { scale: 3,useCORS: true },
                pagebreak: { avoid: "tr", mode: "css", before: "#nextpage1"},
                //pagebreak: { avoid: "tr", mode: "css", before: "#nextpage1", after: "1cm"  },
                // pagebreak: { before: '.beforeClass', after: ['#after1', '#after2'], avoid: 'img' },
                //jsPDF: { unit: 'in', format: [5.5,8.5], orientation: 'landscape' }
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            };

            html2pdf().from(element).set(opt).toPdf().get('pdf').then(function (pdf) {
                // pdf.autoPrint();
                window.open(pdf.output('bloburl'), '_blank');
            });
        }
    }
}
</script>
<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

#nextpage1 {
  margin-top: 250px;  
  page-break-before: always;
}

#printarea{
    padding: 25px;
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 11px;
    line-height: normal;
    box-sizing: border-box;
    page-break-inside: avoid;
}

.footer{
    margin-top: -65px;
    float: left;
    position: absolute;
    padding: 5px;
    /* border-left: 2px solid #088aa3; */
    align-self: center;
}
.footer p{
    font-size: 12px;
    line-height: 0.5px;
}
.botones{
    text-align: right;
    margin-right: 40px;
}

.h2{
	font-size: 11px;
}
.h3{
	font-size: 12pt;
	display: block;
	background: #088aa3;
	color: #FFF;
	text-align: center;
    font-weight: 700;
	padding: 3px;
	margin-bottom: 5px;
}
.h4{
	font-size: 8pt;
	color: #088aa3;
	display: block;

}

#factura_head, #factura_cliente, #factura_detalle{
	width: 100%;
	margin-bottom: 10px;
}

.logo_factura{
	width: 25%;
    text-align: center;
}
.info_empresa{
	width: 50%;
    font-size: 13px;
	text-align: center;
    height: auto;
}

.info_empresa table tr td{
    font-family: "Poppins", sans-serif;
    line-height: 13px;
}

.info_factura{
    line-height: 5px;	
	width: 29%;
    font-size: x-small;
}

.info_factura strong{
	font-size: 9pt;
	color: rgb(43, 43, 43);
}

.info_factura .textof{
    font-family: 'Anton', sans-serif;	
}

.info_cliente{
	width: 100%;
}
.datos_cliente{
	width: 100%;
}
.datos_cliente tr td{
    padding-top: 5px;	
    line-height: 12px;
	font-size: 9pt;
}
.datos_cliente{
	padding: 10px 10px 0 10px;
}



.textright{
	text-align: right;
}
.textleft{
	text-align: left;
}
.textcenter{
	text-align: center;
}
.round{
	border-radius: 10px;
	border: 1px solid ;
    border-color: #088aa3;
	overflow: hidden;
	padding-bottom: 0px;
}
.round p{
	padding: 0 15px;
}

#factura_detalle{
	border-collapse: collapse;
	padding: 10px;
}
#factura_detalle thead tr th{
	background: #088aa3;
	color: #FFF;
	padding: 5px;
}

#detalle_productos tr:nth-child(even) {

    background: #ededed;
}
#detalle_totales span{
	font-family: 'Mako', sans-serif;
}
.nota{
	font-size: 8pt;
}
.label_gracias{
	font-family: verdana;
	font-weight: bold;
	font-style: italic;
	text-align: center;
    color: #088aa3;
    font-size: 15px;
	margin-top: 10px;
}
.anulada{
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translateX(-50%) translateY(-50%);
}

div.productos {
	height: 400px;
	border: 1px solid #088aa3;
	border-radius: 10px;
	overflow: hidden;
	padding: 3px;
}
div.totales{
	margin-top: 5px;
	display: inline-block;
	width: 14%;
	border: 0px solid #180581;
	line-height: 11px;
}
div.letras{
	margin-top: 10px;
	display: inline-block;
	width: 70%;
	border: 0px solid #058170;
	padding: 3px;
}
p.title{
	font-family: 'Anton', sans-serif;
	font-size: 9pt;
}

</style>